import apiClient from '../apiClient';
import { POST_RESEND_DATA_TOUR_TRANSACTION_URL } from '../apiUrl';

const postResendDataTourTransactionApi = Id => {
  return apiClient.post(POST_RESEND_DATA_TOUR_TRANSACTION_URL(Id));
};

export default postResendDataTourTransactionApi;
